/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: eBFTaYn0ldI-

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicFeaturesCard.module.css"; // plasmic-import: eBFTaYn0ldI-/css

createPlasmicElementProxy;

export type PlasmicFeaturesCard__VariantMembers = {};
export type PlasmicFeaturesCard__VariantsArgs = {};
type VariantPropType = keyof PlasmicFeaturesCard__VariantsArgs;
export const PlasmicFeaturesCard__VariantProps = new Array<VariantPropType>();

export type PlasmicFeaturesCard__ArgsType = {
  children?: React.ReactNode;
  title?: string;
  desciption?: string;
};
type ArgPropType = keyof PlasmicFeaturesCard__ArgsType;
export const PlasmicFeaturesCard__ArgProps = new Array<ArgPropType>(
  "children",
  "title",
  "desciption"
);

export type PlasmicFeaturesCard__OverridesType = {
  benefit?: Flex__<"div">;
  image?: Flex__<"div">;
  bottom?: Flex__<"div">;
  top?: Flex__<"div">;
  h3?: Flex__<"h3">;
  p?: Flex__<"p">;
};

export interface DefaultFeaturesCardProps {
  children?: React.ReactNode;
  title?: string;
  desciption?: string;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFeaturesCard__RenderFunc(props: {
  variants: PlasmicFeaturesCard__VariantsArgs;
  args: PlasmicFeaturesCard__ArgsType;
  overrides: PlasmicFeaturesCard__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"benefit"}
      data-plasmic-override={overrides.benefit}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.benefit
      )}
    >
      <div
        data-plasmic-name={"image"}
        data-plasmic-override={overrides.image}
        className={classNames("all", sty.image)}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <PlasmicImg__
              alt={""}
              className={classNames(sty.img__z2Tfa)}
              displayHeight={"239px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/b63c4ec01b7f0b5eb8b9273a00144d1a.svg",
                fullWidth: 374,
                fullHeight: 239,
                aspectRatio: 1.564854
              }}
            />
          ),

          value: args.children
        })}
      </div>
      <div
        data-plasmic-name={"bottom"}
        data-plasmic-override={overrides.bottom}
        className={classNames("all", sty.bottom)}
      >
        <div
          data-plasmic-name={"top"}
          data-plasmic-override={overrides.top}
          className={classNames("all", sty.top)}
        >
          <h3
            data-plasmic-name={"h3"}
            data-plasmic-override={overrides.h3}
            className={classNames(
              "all",
              "h3",
              "h3__bvRZj",
              "__wab_text",
              sty.h3
            )}
          >
            <React.Fragment>{$props.title}</React.Fragment>
          </h3>
          <p
            data-plasmic-name={"p"}
            data-plasmic-override={overrides.p}
            className={classNames("all", "p", "p__bvRZj", "__wab_text", sty.p)}
          >
            <React.Fragment>{$props.desciption}</React.Fragment>
          </p>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  benefit: ["benefit", "image", "bottom", "top", "h3", "p"],
  image: ["image"],
  bottom: ["bottom", "top", "h3", "p"],
  top: ["top", "h3", "p"],
  h3: ["h3"],
  p: ["p"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  benefit: "div";
  image: "div";
  bottom: "div";
  top: "div";
  h3: "h3";
  p: "p";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeaturesCard__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeaturesCard__VariantsArgs;
    args?: PlasmicFeaturesCard__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFeaturesCard__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFeaturesCard__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeaturesCard__ArgProps,
          internalVariantPropNames: PlasmicFeaturesCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeaturesCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "benefit") {
    func.displayName = "PlasmicFeaturesCard";
  } else {
    func.displayName = `PlasmicFeaturesCard.${nodeName}`;
  }
  return func;
}

export const PlasmicFeaturesCard = Object.assign(
  // Top-level PlasmicFeaturesCard renders the root element
  makeNodeComponent("benefit"),
  {
    // Helper components rendering sub-elements
    image: makeNodeComponent("image"),
    bottom: makeNodeComponent("bottom"),
    top: makeNodeComponent("top"),
    h3: makeNodeComponent("h3"),
    p: makeNodeComponent("p"),

    // Metadata about props expected for PlasmicFeaturesCard
    internalVariantProps: PlasmicFeaturesCard__VariantProps,
    internalArgProps: PlasmicFeaturesCard__ArgProps
  }
);

export default PlasmicFeaturesCard;
/* prettier-ignore-end */
